import axios from 'axios';
import { Dispatch } from 'redux';

// Define your action types
const GET_LANGUAGES = 'GET_LANGUAGES';
const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';

// Define the action interface
interface GetLanguagesAction {
  type: typeof GET_LANGUAGES;
  data: any; // Define the type of data you expect
}

interface SetSelectedLanguageAction {
  type: typeof SET_SELECTED_LANGUAGE;
  language: string; // Define the type based on your language structure
}

// Define the action creator function
export const getLanguages = (activated = true) => async (dispatch: Dispatch<GetLanguagesAction>) => {
  try {
    const response = await axios.get(process.env.NEXT_PUBLIC_SOCKET + '/api/languages', {
      //params: { activated },
      //headers: { Authorization: `Token ${token}` }
    });

    if (response.data.data) {
      dispatch({
        type: GET_LANGUAGES,
        data: response.data.data,
      });
    } else {
      // Handle the case when data is not available
      // You can dispatch another action or handle it as needed
    }
  } catch (error) {
    // Handle any errors from the API request
    // You can dispatch an error action or handle it as needed
  }
};

export const setSelectedLanguage = (language: string) => (dispatch: Dispatch<SetSelectedLanguageAction>) => {
  dispatch({
    type: SET_SELECTED_LANGUAGE,
    language,
  });
};

// Define the state type
interface SettingsState {
    languages: any[]; // Define the type of languages as needed
    selectedLanguage: string | null; // New field for selected language
  }
  
  const initialState: SettingsState = {
    languages: [],
    selectedLanguage: null,
  };
  
  const settings = (state: SettingsState = initialState, action: GetLanguagesAction | SetSelectedLanguageAction) => {
    switch (action.type) {
      case GET_LANGUAGES: {
        return {
          ...state,
          languages: action.data,
        };
      }
      case SET_SELECTED_LANGUAGE: {
        return {
          ...state,
          selectedLanguage: action.language,
        };
      }
      default: {
        return state;
      }
    }
  };
  
  export default settings;